import { BaseRepository } from '@wephone-core/model/repository/base_repository';
import { PaymentAttemptEntity } from '@wephone-core/model/entity/payment_attempt';

export class PaymentAttemptRepository extends BaseRepository {
  ENTITY_CLASS = PaymentAttemptEntity;
  protected URL_PREFIX = 'payment_attempt';
}
